/** Foundry's `sluggify` (src/util/misc.ts), so slugs derived from names match upstream data. */

const wordCharacter = String.raw`[\p{Alphabetic}\p{Mark}\p{Decimal_Number}\p{Join_Control}]`;
const nonWordCharacter = String.raw`[^\p{Alphabetic}\p{Mark}\p{Decimal_Number}\p{Join_Control}]`;
const nonWordCharacterRE = new RegExp(nonWordCharacter, "gu");
const nonWordBoundary = String.raw`(?:${wordCharacter})(?=${wordCharacter})`;
const lowerCaseThenUpperCaseRE = new RegExp(String.raw`(\p{Lowercase_Letter})(\p{Uppercase_Letter}${nonWordBoundary})`, "gu");

export function sluggify(text: string): string {
  if (text === "-") return text;
  return text
    .replace(lowerCaseThenUpperCaseRE, "$1-$2")
    .toLowerCase()
    .replace(/['’]/g, "")
    .replace(nonWordCharacterRE, " ")
    .trim()
    .replace(/[-\s]+/g, "-");
}

/** Foundry's `sluggify(text, { camel: "dromedary" })`: "first-tome-skill" -> "firstTomeSkill". */
export function sluggifyCamel(text: string): string {
  const words = text
    .replace(/[^-_\p{Alphabetic}\p{Mark}\p{Decimal_Number}\s]/gu, "")
    .replace(/[-_]+/g, " ")
    .trim()
    .split(/\s+/)
    .filter((w) => w.length > 0);
  return words.map((w, i) => (i === 0 ? w.charAt(0).toLowerCase() + w.slice(1) : w.charAt(0).toUpperCase() + w.slice(1))).join("");
}
